import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Spin from 'antd/lib/spin';
import rules from '../../../common/rules/rules';
import PaymentInstructions from '../../allocations/components/PaymentInstructions'
import AccountStatistic from '../../allocations/components/AccountStatistic';
import { ResponsiveTable } from '../../../common/components/data-display';
import Table from 'antd/lib/table';
import { formatDate, currencyFormatter } from '../../../common/utils/helpers';
import { accountRoles } from '../../../common/enums';

const { Column } = Table;

@translate()
@Form.create()
export default class WithdrawFunds extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    onWithdraw: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    accountBalance: PropTypes.number.isRequired,
    investedAmount: PropTypes.string,
    isLoadingPayments: PropTypes.bool.isRequired,
    isLoadingInvestedAmount: PropTypes.bool.isRequired,
    role: PropTypes.string
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields({ force: true }, (err, values) => {
      if (!err) {
        this.props.onWithdraw(values.amount);
      }
    });
  };

  render() {
    const { 
      t, 
      isLoading, 
      accountBalance, 
      payments, 
      investedAmount,
      isLoadingPayments,
      isLoadingInvestedAmount,
      role,
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    const receivedSum = isLoadingPayments ? null : payments
      .map(payment => payment.amount * ((payment.BankExportId) ? -1 : 1))
      .reduce((sum, amount) => sum + parseFloat(amount), 0);

    const profit = isLoadingInvestedAmount || isLoadingPayments ? null : (+investedAmount + accountBalance - receivedSum);

    return (
      <Spin spinning={isLoading}>
        <Row className="withdraw-funds-wrapper">
          <section className="withdraw-funds-wrapper col-xs-12 col-md-6">
            <PaymentInstructions></PaymentInstructions>
          </section>
          <section className="withdraw-funds-wrapper panel-wrapper col-xs-12 col-md-6">
            <Row>
              <Col xs={12}>
                <h2>{t('Výber peňazí')}</h2>
              </Col>
              <Col xs={12} md={12} >
                <Form onSubmit={this.handleSubmit}>
                  <Row>
                    <Col xs={8} md={8}>
                      <Form.Item>
                        {getFieldDecorator('amount', {
                          rules: rules.withdrawalAmount(accountBalance),
                        })(<Input size="default" placeholder={t('Zadajte sumu')} />)}
                      </Form.Item>
                    </Col>
                    <Col xs={4} md={4}>
                      <Form.Item>
                        <Button size="small" type="primary" htmlType="submit">
                          {t('Odoslať')}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </section>
        </Row>
        <br></br>
        { role !== accountRoles.EXECUTOR && <Row className="statistic-wrapper">
          <section className="panel-wrapper col-xs-12">
            <AccountStatistic
            investingSum={accountBalance}
            investedSum={investedAmount}
            receivedSum={receivedSum}
            profit={profit}
            isLoadingInvestedAmount={isLoadingInvestedAmount}
            ></AccountStatistic>
          </section>
        </Row>}
        <br></br>
        <Row className="statistic-wrapper">
          <section className="panel-wrapper col-xs-12 text-center">
            <div>
              <h2 style={{ marginTop: 20 }}>Pohyby na účte</h2>
              <ResponsiveTable dataSource={payments} rowKey={item => item.id} pagination={false}>
                <Column
                  title={t('Dátum platby')}
                  width="70%"
                  render={(text, item) => (
                    <span>
                      {formatDate(item.transferredAt)}
                    </span>
                  )} 
                />
                <Column title={t('VS')} key="variableSymbol" dataIndex="variableSymbol" />
                <Column
                  title={t('Suma')}
                  key="amount"
                  dataIndex="amount"
                  render={(text, item)=>(
                    <span className={(item.BankExportId) ? "leave" : "received"}>
                    {(item.BankExportId) ? '-' : '+'} {currencyFormatter(item.amount)}
                    </span>
                  )}
                />
              </ResponsiveTable>
            </div>
          </section>
        </Row>
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payments/components/WithdrawFunds.js